import React, { FC } from 'react';

import { Badge } from 'evergreen-ui';

export const ActiveBadge: FC<{ active?: boolean }> = ({ active }) =>
  active ? <Badge color="green">Active</Badge> : <Badge color="red">Terminated</Badge>;
